import {
  BaseRepository,
  IBaseModel,
  IListFetchParams,
  MODULE,
  MN_ACTIVITIES,
  MN_CUSTOMERS,
  MN_GESTIFY_CREDENTIALS,
  MN_JOBS,
  MN_ORDERS,
  MN_ORDER_COUNTERS,
  MN_RESOURCES,
  MN_RESOURCE_SKILLS,
  MN_SKILLS,
  MN_SUPPLIERS,
  MN_TIMESHEET,
  MN_TIMESHEET_LOCK,
  MN_TYPE_OF_PAYMENTS,
  MN_USERS,
  MN_SCHEDULED_VALUES,
} from '../common';
import ActivityRepository from './activity';
import CustomerRepository from './customer';
import JobRepository from './job';
import OrderRepository from './order';
import ResourceRepository from './resource';
import ResourceSkillRepository from './resourceSkill';
import SkillRepository from './skill';
import SupplierRepository from './supplier';
import TypOfPaymentRepository from './typeOfPayment';
import UserRepository from './user';
import TimesheetRepository from './timesheet';
import TimesheetLockRepository from './timesheetLock';
import OrderCounterRepository from './orderCounter';
import GestifyCredentialRepository from './gestifyCredentials';
import ScheduledValueRepository from './scheduledValues';

type Constructor<T> = new (...args: any[]) => T;

const repositories = {
  [MN_ACTIVITIES]: ActivityRepository,
  [MN_CUSTOMERS]: CustomerRepository,
  [MN_JOBS]: JobRepository,
  [MN_GESTIFY_CREDENTIALS]: GestifyCredentialRepository,
  [MN_ORDERS]: OrderRepository,
  [MN_ORDER_COUNTERS]: OrderCounterRepository,
  [MN_RESOURCES]: ResourceRepository,
  [MN_RESOURCE_SKILLS]: ResourceSkillRepository,
  [MN_SCHEDULED_VALUES]: ScheduledValueRepository,
  [MN_SKILLS]: SkillRepository,
  [MN_SUPPLIERS]: SupplierRepository,
  [MN_TIMESHEET]: TimesheetRepository,
  [MN_TIMESHEET_LOCK]: TimesheetLockRepository,
  [MN_TYPE_OF_PAYMENTS]: TypOfPaymentRepository,
  [MN_USERS]: UserRepository,
};

export function createRepository<
  T extends IBaseModel,
  Q extends IListFetchParams,
>(moduleName: MODULE): BaseRepository<T, Q> {
  const RepoClass = repositories[moduleName] as unknown as Constructor<
    BaseRepository<T, Q>
  >;
  return new RepoClass(moduleName);
}
